module.exports = __webpack_public_path__ + "img/PorkTheUnitedStates.0adb104e.png";